export function isPreCalcFlagOn(value) {
  return value === true || value === "true";
}

export function sanitizePreCalcPartSinglePropertyPtor(part, isOnlyProperty) {
  if (!part) return part;
  if (!isPreCalcFlagOn(isOnlyProperty)) {
    part.isSinglePropertyPtorAllowed = false;
    part.hasTzinunOnPtor = false;
  }
  return part;
}

export function sanitizePreCalcSinglePropertyPtor(preCalc) {
  if (!preCalc || !Array.isArray(preCalc.preCalcPartsData)) return preCalc;
  preCalc.preCalcPartsData.forEach((part) => {
    sanitizePreCalcPartSinglePropertyPtor(part, preCalc.isOnlyProperty);
  });
  return preCalc;
}
